import { Role } from '../../mappers/business/toBusinessModel';
import { BusinessRegistrationStatus } from '../../mappers/users/toUserModel';
import type { BusinessUI } from '../business/types';

export enum CollectionStatus {
    PUBLISHED = 'published',
    DECLINED = 'declined',
    MODERATION = 'moderation',
    DRAFT = 'draft',
    LIMITED = 'limited',
}

export type UserUI = {
    id: string;
    profile?: BusinessUI;
    subscriptions: number;
    avatarUrl?: string;
    displayName: string;
    login: string;
    role: Role;
    businessRegistrationStatus?: BusinessRegistrationStatus;
};

type MediaImageUI = {
    id: string;
    type: 'image';
    media: Inspire.Image[];
};

export type MediaVideoUI = {
    id: string;
    type: 'video';
    media: Inspire.Video[];
};

export type PreviewItemUI = MediaImageUI | MediaVideoUI;

export interface CollectionFeedStatus {
    showInFeed: boolean;
}

export type CollectionAuthorType = 'user' | 'blogger';

export interface CollectionUI {
    id: string;
    url: string;
    displayName: string;
    numberOfPosts: number;
    createdAt: string;
    previewItems: PreviewItemUI[];
    modifiable: boolean;
    defaultCollection: boolean;
    isPublic: boolean;
    isSaved: boolean;
    sharingUrl: string;
    author?: {
        id: string;
        displayName: string;
        authorType?: CollectionAuthorType;
        avatarUrl: Inspire.Image[];
        shareLink: string;
    };
    status: CollectionStatus;
    feedStatus?: CollectionFeedStatus;
    isLiked: boolean;
    likes: number;
    footerData?: {
        feedButtonText: string;
    };
    promoteShowInFeedAvailable?: boolean;
}

export interface CollectionPersistenceUI {
    id?: string;
    displayName: string;
    isPublic: boolean;
    numberOfPosts?: number;
    feedStatus?: CollectionFeedStatus;
}

export interface CollectionValues {
    collectionName: string;
    showInFeed: boolean;
    isPublic: boolean;
    suggests: string[];
    currentSuggest: string;
    suggestsLoading: boolean;
    canShowInFeed: boolean;
    numberOfPosts?: number;
}

export interface CollectionHandlers {
    onIsPublicChange: VoidFunction;
    onInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    onShowInFeedChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    onSubmit: VoidFunction;
    onChooseSuggest: (suggest: string) => void;
}
